import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=fefb164c&scoped=true"
import script from "./PersonalDetails.vue?vue&type=script&lang=js"
export * from "./PersonalDetails.vue?vue&type=script&lang=js"
import style0 from "./PersonalDetails.vue?vue&type=style&index=0&id=fefb164c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefb164c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fefb164c')) {
      api.createRecord('fefb164c', component.options)
    } else {
      api.reload('fefb164c', component.options)
    }
    module.hot.accept("./PersonalDetails.vue?vue&type=template&id=fefb164c&scoped=true", function () {
      api.rerender('fefb164c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/ArchivesViewPage/components/PersonalDetails.vue"
export default component.exports